module.exports = __webpack_public_path__ + "/build/web/images/hero-search@2x.418d41b8a01d9a1fa6f94b6e388f937c.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-search@2x.jpg
// module id = 143
// module chunks = 13